<template>
  <vue-tel-input :value="value"
                 :inputOptions="{'placeholder': placeholder}"
                 @input="onInput" mode="international"/>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "PhoneInput",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: () => i18n.t('Phone number')
    }
  },
  methods: {
    onInput(val){
      if (this.value !== val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../bootstrap/import";


.vue-tel-input {
  width: 100%;

  &.is-invalid {
    border-color: $danger;
  }

  &.is-valid {
    border-color: $success;
  }
}

/deep/ {
  .vti__dropdown {
    padding: 9px;
  }
}

</style>

<style lang="scss">
@import "../../bootstrap/import";
</style>
